import { render } from "./TemplateModalWeatherStation.vue?vue&type=template&id=5638d344&ts=true"
import script from "./TemplateModalWeatherStation.vue?vue&type=script&lang=ts"
export * from "./TemplateModalWeatherStation.vue?vue&type=script&lang=ts"

import "./TemplateModalWeatherStation.vue?vue&type=style&index=0&id=5638d344&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__